/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/ReorderPagesScreenConfiguration.yaml
import { BackgroundStyle, ButtonConfiguration, ForegroundStyle, StyledText } from '../common/Common';
import { UserGuidanceConfiguration } from '../common/UserGuidanceConfiguration';
/**
Configuration of the screen for reordering the scanned pages.
*/
export class ReorderPagesScreenConfiguration {
    /** @param source {@displayType `DeepPartial<ReorderPagesScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          Configuration of the 'cancel' button, located in the top bar.
          */
        this.topBarBackButton = new ButtonConfiguration({
            visible: true,
            text: '?reorderTopBarCancelButtonTitle',
            accessibilityDescription: '?accessibilityDescriptionReorderTopBarCancelButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ iconVisible: true, color: '?sbColorOnPrimary', useShadow: false }),
        });
        /**
          Configuration of the title, located in the top bar.
          */
        this.topBarTitle = new StyledText({ text: '?reorderPageTitle', color: '?sbColorOnPrimary' });
        /**
          Configuration of the 'confirm' button, located in the top bar.
          */
        this.topBarConfirmButton = new ButtonConfiguration({
            visible: true,
            text: '?reorderTopBarConfirmButtonTitle',
            accessibilityDescription: '?accessibilityDescriptionReorderTopBarConfirmButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ iconVisible: true, color: '?sbColorOnPrimary', useShadow: false }),
        });
        /**
          The background color of the reorder pages screen.
          
          Default is "?sbColorOutline"
          */
        this.backgroundColor = '?sbColorOutline';
        /**
          Configuration of the static user guidance, located just below the top bar.
          */
        this.guidance = new UserGuidanceConfiguration({
            title: new StyledText({ text: '?reorderPageGuidanceTitle', color: '?sbColorOnPrimary' }),
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '?sbColorSurfaceLow', strokeWidth: 0.0 }),
        });
        /**
          Configuration of the title below each page object.
          */
        this.pageTextStyle = new StyledText({ text: '?reorderPageText', color: '?sbColorOnSurface' });
        if (source.topBarBackButton !== undefined) {
            this.topBarBackButton = new ButtonConfiguration(source.topBarBackButton);
        }
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = new StyledText(source.topBarTitle);
        }
        if (source.topBarConfirmButton !== undefined) {
            this.topBarConfirmButton = new ButtonConfiguration(source.topBarConfirmButton);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.guidance !== undefined) {
            this.guidance = new UserGuidanceConfiguration(source.guidance);
        }
        if (source.pageTextStyle !== undefined) {
            this.pageTextStyle = new StyledText(source.pageTextStyle);
        }
    }
}
//# sourceMappingURL=ReorderPagesScreenConfiguration.js.map